<div>
  <div class="grid grid-cols-1 gap-6">
    <nz-form-item class="flex">
      <nz-form-control>
        <input
          type="text"
          nz-input
          class="w-full"
          [(ngModel)]="this.name"
          [placeholder]="'shared.addEditTags.placeholder' | transloco"/>
      </nz-form-control>
    </nz-form-item>
  </div>
</div>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'shared.addEditTags.buttons.close' | transloco }}</button>
  <button nz-button nzType="primary" [nzLoading]="this.isButtonLoading" (click)="this.entryType === 'new' ? this.addNewTag(): this.editTag()"
          [disabled]="this.name ===''">
    {{ this.entryType === 'new' ? ('shared.addEditTags.buttons.add' | transloco) : ('shared.addEditTags.buttons.edit' | transloco) }}
  </button>
</div>
